module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sideview-button"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3084c2d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sideview-button.vue
// module id = 332
// module chunks = 1